import {
    CmpsInsightCoachingPerformanceData,
    CmpsInsightCoachingPerformanceDropDownContent,
} from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { SystemComponent } from '../../insight/config.insight.model';
import { epicDependencies } from '../../store';
import { PerformanceDataViewTypeTranslationMap } from '../constants/performance-data-view-type-translation-map.ts';
import { MetricItem } from '../models/metric-item.model';
import { PerformanceCardPillarData } from '../models/performance-card-pillar-data.model';
import { PillarItem } from '../models/pillar-item.model';

import { extractMetrics } from './extract-metrics.function';
import { getDropDownData } from './get-drop-down-data.function';
import { getProgressDataForPillar } from './get-progress-data-for-pillar.function';
function createPillarItem(
    card: PerformanceCardPillarData,
    progressBarData: CmpsInsightCoachingPerformanceData[],
    dropdownContent: CmpsInsightCoachingPerformanceDropDownContent[],
    metrics: MetricItem[],
): PillarItem {
    return {
        titleLabel: card.name,
        progressBarData,
        comparePillars: [],
        dropdownContent,
        metrics,
    };
}

function createChildPillarItem(
    pillar: PerformanceCardPillarData,
    translateService: TranslateService,
    progressBarData: CmpsInsightCoachingPerformanceData[],
): PillarItem {
    return {
        titleLabel:
            pillar.name ??
            translateService.instant(
                PerformanceDataViewTypeTranslationMap[pillar.viewType],
            ),
        viewType: pillar.viewType,
        progressBarData,
        comparePillars: performancePillars(pillar),
        isChildPillar: true,
        isVisible: false,
        metrics:
            pillar.colourGroups.length > 0
                ? pillar.colourGroups[0].metrics
                : [],
    };
}

export function performancePillars(
    card: PerformanceCardPillarData,
    component?: SystemComponent,
): PillarItem[] {
    if (epicDependencies == null || epicDependencies.injector == null) {
        return [];
    }
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);

    const totalProgressData = getProgressDataForPillar(card.colourGroups);
    const dropdownContent = getDropDownData(card.comparePillars, component);
    const metrics = extractMetrics(card.colourGroups);

    const mainPillar = createPillarItem(
        card,
        totalProgressData,
        dropdownContent,
        metrics,
    );
    const childPillars =
        card.comparePillars?.map((pillar) => {
            const childPillarProgressData = getProgressDataForPillar(
                pillar.colourGroups,
            );
            return createChildPillarItem(
                pillar,
                translateService,
                childPillarProgressData,
            );
        }) ?? [];

    return [mainPillar, ...childPillars];
}
